import React, { Component, createRef } from "react";
import ReactDOM from "react-dom";

// CSS
import "./Lessons.scss";
import "primeflex/primeflex.css";

// Helper
import { setCookie, checkCookie } from "../../Helper/Cookies";
import { apiFetch, getCurrentUser, uploadCourseMedia, previewLink } from "../../Helper/Api";

// Components
import Header from "../../components/Header/Header";
import { SelectEmpty } from "../../components/UI/Controls";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

// Properties
const properties = require("../../properties.json");

class AddLessons extends Component {
  constructor(props) {
    super(props);
    this.toast = createRef(null);
  }

  state = {
    // Where the save button goes when this form is mounted in a panel: the
    // panel keeps a slot on its fixed header row. Null on the standalone
    // page, where the button keeps its own bar at the end of the form.
    headerSlot: null,

    // Submit Button
    buttonText: "إضافة حصة",
    buttonColor: "",

    // Form Select Boxes
    type: null,
    period: null,
    grade: null,
    material: null,
    // Set The Video Type
    setVideoType: null,

    getPeriods: [],
    getMaterialsList: [],
    // All Grades
    allGrades: [],

    // a menu with nothing in it yet says which of the two it is: still
    // loading, or genuinely empty
    loadingGrades: true,
    loadingMaterials: false,
    loadingPeriods: false,

    reply: null,
    currentReplyID: null,
    thumbs: [],
    voices: [],
    // Lesson Data
    formContent: {
      branchId: getCurrentUser()?.branchId,
      companyId: properties.company_id,
      lessonName: null,
      lessonDescription: null,
      lessonType: null,
      schoolId: null,
      periodId: null,
      materialId: null,
  
      images: [],
      schoolId:null,
      // thumbs:[],
      documents: [],
    
      voiceLink: null,
      lessonVoiceList:[],
      videoLinks:[],
      youtubeLinks: [],
      vimeoLinks: [],
      videoLink:null,

      teacherId: null,
    },
    
    videos:{
      lessonVideoList:[],
      youtubeLink: [],
      vimeoLink: [],
    },
    youtubeLink: null,
      vimeoLink: null,
  };

  changeVideoType = (e) => {
    this.setState({
      setVideoType: e.value,
      
        // ...this.state.videos,
        // youtubeLink: [],
        // vimeoLink: [],
        // lessonVideoList:[]
      
    });
  };

  getPeriod(materialId) {
    this.setState({ loadingPeriods: true });
    apiFetch("/periods/by-material", { query: { materialId } })
      .then((grades) => {
        this.setState({ getPeriods: grades, loadingPeriods: false });
      })
      .catch((error) => {
        this.setState({ loadingPeriods: false });
        console.error("Error:", error);
      });
  }

  getMaterialByStage = (schoolStagesId) => {
    this.setState({ loadingMaterials: true });
    apiFetch("/lookup/materials/by-stage", { query: { stageId: schoolStagesId } })
      .then((fetchMaterials) => {
        this.setState({
          getMaterialsList: fetchMaterials,
          loadingMaterials: false,
        });
      })
      .catch((error) => {
        this.setState({ loadingMaterials: false });
        console.error("Error:", error);
      });
  };

  componentDidMount() {
    document.title = properties.site_name + " | إضافة حصة جديدة";

    // In a panel the save belongs on the header row, where it stays in sight
    // however long the form gets. It is moved there with a portal, so it
    // never leaves this component's tree -- its label and its colour are
    // still driven from this state -- and the `form` attribute on it is what
    // keeps a native submit, and the browser's own required checks, working
    // from outside the <form>. The tree is mounted before this runs, so the
    // slot is already in the DOM if there is one.
    if (this.props.inPanel) {
      const slot = document.querySelector(".ui-panel-slot");
      if (slot) this.setState({ headerSlot: slot });
    }

    // Redirect To Sign In Page If The User Is Already Logged Out & Remove The Data If It Exists
    if (!checkCookie("name")) {
      window.localStorage.removeItem("currentTeacher");
      window.location.href = `/`;
    }

    apiFetch("/lookup/school-stages/by-teacher", { query: { teacherUserId: getCurrentUser()?.userId } })
      .then((grades) => {
        this.setState({ allGrades: grades, loadingGrades: false });
      })
      .catch((error) => console.error("Error:", error));
  }

  render() {
    // The save stays out of reach until the form can actually be saved --
    // the same fields the inputs already mark `required`, read here so the
    // button can say so before it is pressed rather than after.
    const f = this.state.formContent;
    const filled = (v) => v !== null && v !== undefined && String(v).trim() !== "";
    const canSave =
      filled(f.lessonName) &&
      filled(f.lessonType) &&
      filled(this.state.grade) &&
      filled(this.state.material) &&
      filled(this.state.period) &&
      filled(f.lessonDescription);

    const typeList = [
      { label: "مدفوع", value: 0 },
      { label: "مجاني", value: 1 },
    ];

    const videoType = [
        {label: 'Youtube', value: 0},
        {label: 'سيرفر', value: 1},
        {label: 'Vimeo', value: 2}
    ];
    let materialList = this.state.getMaterialsList.map((period) => {
      return { label: period.name, value: period.id };
    });

    let periods = this.state.getPeriods.map((period) => {
      return { label: period.name, value: period.id };
    });

    const grades = this.state.allGrades.map((grade) => {
      return {
        label: grade.name,
        value: grade.id,
      };
    });

    // All four upload handlers below used to POST to legacy PHP scripts (upload-video.php,
    // upload-thumb.php, upload-pdf.php) on the old pre-migration host -- those don't exist on
    // the new gateway, so every upload here 404'd/CORS-failed. Now uploads go through the same
    // Contabo-backed endpoint the Courses feature uses (uploadCourseMedia), which returns a full
    // public URL directly -- no more ${uploads_path}/videos/<filename> reconstruction needed.
    const uploadVideo = async (e) => {
      const file = e.files && e.files[0];
      if (!file) return;
      try {
        const url = await uploadCourseMedia(file, undefined, undefined, { materialId: this.state.formContent.materialId });
        this.setState({ formContent: { ...this.state.formContent, videoLinks: this.state.formContent.videoLinks.concat(url) } });
        this.toast.current.show({ severity: "info", summary: "تم بنجاح", detail: "تم رفع الفيديو" });
      } catch (error) {
        console.error("Error:", error);
        this.toast.current.show({ severity: "error", summary: "لم تتم العملية", detail: error.message || "فشل رفع الفيديو" });
      } finally {
        e.options && e.options.clear && e.options.clear();
      }
    };

    const onUploadVoice = async (e) => {
      const file = e.files && e.files[0];
      if (!file) return;
      try {
        const url = await uploadCourseMedia(file, undefined, undefined, { materialId: this.state.formContent.materialId });
        this.setState({ formContent: { ...this.state.formContent, lessonVoiceList: this.state.formContent.lessonVoiceList.concat(url) } });
        this.toast.current.show({ severity: "info", summary: "تم بنجاح", detail: "تم رفع الصوت" });
      } catch (error) {
        console.error("Error:", error);
        this.toast.current.show({ severity: "error", summary: "لم تتم العملية", detail: error.message || "فشل رفع الصوت" });
      } finally {
        e.options && e.options.clear && e.options.clear();
      }
    };

    const onUploadThumb = async (e) => {
      const file = e.files && e.files[0];
      if (!file) return;
      try {
        const url = await uploadCourseMedia(file, undefined, undefined, { materialId: this.state.formContent.materialId });
        this.setState({ thumbs: this.state.thumbs.concat(url) });
        this.toast.current.show({ severity: "info", summary: "تم بنجاح", detail: "تم رفع الصورة المصغرة" });
      } catch (error) {
        console.error("Error:", error);
        this.toast.current.show({ severity: "error", summary: "لم تتم العملية", detail: error.message || "فشل رفع الصورة" });
      } finally {
        e.options && e.options.clear && e.options.clear();
      }
    };

    const onUploadPDFs = async (e) => {
      const file = e.files && e.files[0];
      if (!file) return;
      try {
        const url = await uploadCourseMedia(file, undefined, undefined, { materialId: this.state.formContent.materialId });
        this.setState({ formContent: { ...this.state.formContent, documents: this.state.formContent.documents.concat(url) } });
        this.toast.current.show({ severity: "info", summary: "تم بنجاح", detail: "تم رفع المذكرات" });
      } catch (error) {
        console.error("Error:", error);
        this.toast.current.show({ severity: "error", summary: "لم تتم العملية", detail: error.message || "فشل رفع المذكرة" });
      } finally {
        e.options && e.options.clear && e.options.clear();
      }
    };
    let uploadVideoYoutube = (link) => {
      let _this = this;
      // let videosArray = uploadedFiles.files;

      if (link !== "") 

         {
              _this.setState({formContent: {
                  // ...this.state.formContent,
                  ...this.state.formContent,
                  youtubeLinks: this.state.formContent.youtubeLinks.concat(link),
              }});
              // this.state.videos.youtubeLink=null
              console.log( this.state.formContent)
              _this.toast.current.show({severity: 'info', summary: 'تم بنجاح', detail: 'تم اضافه الفيديو'});
          
          

      } else {
          _this.toast.current.show({severity: 'error', summary: 'تحذير', detail: 'لا يمكنك الرفع '});
      }
  }
  let uploadVideoViemo = (link) => {
    let _this = this;
    // let videosArray = uploadedFiles.files;

    if (link !== "") 

       {
            _this.setState({formContent: {
                // ...this.state.formContent,
                ...this.state.formContent,
                vimeoLinks: this.state.formContent.vimeoLinks.concat(link),
            }});
            // this.state.videos.youtubeLink=null
            console.log( this.state.videos)
            _this.toast.current.show({severity: 'info', summary: 'تم بنجاح', detail: 'تم اضافه الفيديو'});
        
        

    } else {
        _this.toast.current.show({severity: 'error', summary: 'تحذير', detail: 'لا يمكنك الرفع '});
    }
}
    var addLesson = (e) => {
      var _this = this;
      e.preventDefault();
      var _data = JSON.parse(window.localStorage.getItem("currentTeacher"));
     
      this.setState({
        buttonText: "جاري الإضافة ...",
        buttonColor: "loading",
      });

      this.setState({
        formContent: {
          ...this.state.formContent,
          images: this.state.thumbs,
        },
      }, () => {
        apiFetch("/lessons", {
          method: "POST",
          body: {
            lessonName: this.state.formContent.lessonName,
            lessonType: this.state.formContent.lessonType,
            lessonDescription: this.state.formContent.lessonDescription,
            branchId: this.state.formContent.branchId,
            schoolStagesGuideId: this.state.formContent.schoolId,
            periodId: this.state.formContent.periodId,
            materialId: this.state.formContent.materialId,
            images: this.state.formContent.images,
            voices: this.state.formContent.lessonVoiceList,
            videoLinks: this.state.formContent.videoLinks,
            vimeoLinks: this.state.formContent.vimeoLinks,
            youtubeLinks: this.state.formContent.youtubeLinks,
          },
        })
          .then((created) => {
            _this.setState({
              buttonText: "إضافة حصة",
              buttonColor: "",
            });
            // POST /lessons doesn't accept documents directly (DocumentRequest needs a real
            // lessonId, which only exists after this create succeeds) -- attach any pending
            // uploads now that we have one.
            const pendingDocuments = _this.state.formContent.documents || [];
            if (created && created.id && pendingDocuments.length) {
              Promise.all(
                pendingDocuments.map((link) =>
                  apiFetch("/documents", {
                    method: "POST",
                    body: { link, branchId: _this.state.formContent.branchId, lessonId: created.id },
                  })
                )
              ).catch((error) => console.error("Error saving documents:", error));
            }
            _this.toast.current.show({
              severity: "success",
              summary: "تم بنجاح",
              detail: "تم الحفظ بنجاح",
            });

            // Saved from inside a panel: whoever opened it closes it and
            // refetches its table. On the standalone page there is no
            // onSaved, so the page behaves exactly as it always did.
            if (_this.props.onSaved) _this.props.onSaved(created);
          })
          .catch((error) => {
            console.error("Error:", error);

            _this.setState({
              buttonText: "إضافة حصة",
              buttonColor: "",
            });

            _this.toast.current.show({
              severity: "error",
              summary: "لم تتم العملية",
              detail: error.message || "خطأ في الإتصال",
            });
          });
      });
    };

    return (
      // `inPanel` is presentation only: the panel already says what this form
      // is, so the page's own title strip and the card's title step aside.
      // Everything else -- fields, uploads, submit -- is untouched, and
      // /lessons/add still mounts this same component as a page.
      <div className={this.props.inPanel ? "add-lesson-page in-panel" : "add-lesson-page"}>
        {this.props.inPanel ? null : <Header pageName="إضافة حصة" />}

        <div className="content">
          <Toast ref={this.toast}></Toast>

          <div className="container">
            <Card title={this.props.inPanel ? null : "إدخال حصة جديد"}>
            {/* Same link, same target -- it just looks like what it is now:
                a short way out to a video, not a button competing with the
                form's own save. */}
            <a
              className="ui-linkcard"
              href="https://bobbyhadz.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="ic" aria-hidden="true">
                <i className="pi pi-play"></i>
              </span>
              <span className="tx">
                <b>فيديو الشرح</b>
                <small>شوف طريقة إضافة الحصة خطوة بخطوة قبل ما تبدأ</small>
              </span>
              <i className="pi pi-arrow-left go" aria-hidden="true"></i>
            </a>
              <form id="add-lesson-form" onSubmit={addLesson} action="#" method="POST">
                {/* The form is read in six passes, so it is written in six.
                    Nothing inside a section changed -- same fields, same
                    props, same order, same handlers; they are only grouped
                    under a heading that says what the group is for. */}
                <section className="ui-sec" style={{ "--d": "0ms" }}>
                  <h3>
                    <span className="n">١</span>
                    <span className="t">
                      معلومات الحصة
                      <small>اسم الحصة ومكانها: المرحلة، المادة والفترة</small>
                    </span>
                  </h3>
                <div className="p-grid p-fluid">
                  <div className="p-col-12 p-md-4">
                    <div className="p-inputgroup">
                      <span className="p-float-label">
                        <InputText
                          id="lesson-name"
                          required
                          value={this.state.formContent.lessonName}
                          name="lesson-name"
                          type="text"
                          onChange={(e) => {
                            this.setState({
                              formContent: {
                                ...this.state.formContent,
                                lessonName: e.target.value,
                              },
                            });
                          }}
                        />

                        <label htmlFor="lesson-name">إسم الحصة</label>
                      </span>
                    </div>
                  </div>
                  <div className="p-col-12 p-md-4">
                    <div className="p-inputgroup">
                      <span className="p-float-label">
                        <Dropdown
                          value={this.state.type}
                          options={typeList}
                          required
                          onChange={(e) =>
                            this.setState({
                              type: e.value,
                              formContent: {
                                ...this.state.formContent,
                                lessonType: e.value,
                              },
                            })
                          }
                          name="type"
                          placeholder="اختر"
                        />
                          <label>نوع الحصة</label>
                      </span>
                    </div>
                  </div>
                  <div className="p-col-12 p-md-4 p-mt-3">
                    <div className="p-inputgroup">
                      <span className="p-float-label">
                        <Dropdown
                          value={this.state.grade}
                          options={grades}
                          required
                          onChange={ (e) =>
                            this.setState({
                              grade: e.value,
                              formContent: {
                                ...this.state.formContent,
                                schoolId: e.value,
                              },
                              
                            },
                            this.getMaterialByStage(e.value )
                            ) 
                          }
                          
                          name="grade"
                          placeholder="اختر"
                          emptyMessage={<SelectEmpty loading={this.state.loadingGrades} />}
                        />
                          <label>المرحلة الدراسية</label>
                      </span>
                    </div>
                  </div>
                  <div className="p-col-12 p-md-4 p-mt-3">
                    <div className="p-inputgroup">
                      <span className="p-float-label">
                        <Dropdown
                          value={this.state.material}
                          options={materialList}
                          required
                          onChange={(e) =>
                            this.setState({
                              material: e.value,
                              formContent: {
                                ...this.state.formContent,
                                materialId: e.value,
                              },
                            },
                            this.getPeriod(e.value )
                            )
                          }
                          name="subject"
                          placeholder="اختر"
                          emptyMessage={<SelectEmpty loading={this.state.loadingMaterials} />}
                          // the materials belong to a stage, so there is
                          // nothing to choose from until one is picked
                          disabled={!this.state.grade}
                        />
                          <label>
                            المادة
                            {!this.state.grade ? (
                              <small className="ui-fieldhint">اختر المرحلة الدراسية الأول</small>
                            ) : null}
                          </label>
                      </span>
                    </div>
                  </div>
                  <div className="p-col-12 p-md-4 p-mt-3">
                    <div className="p-inputgroup">
                      <span className="p-float-label">
                        <Dropdown
                          value={this.state.period}
                          options={periods}
                          required
                          onChange={(e) =>
                            this.setState({
                              period: e.value,
                              formContent: {
                                ...this.state.formContent,
                                periodId: e.value,
                              },
                            })
                          }
                          name="months"
                          placeholder="اختر"
                          emptyMessage={<SelectEmpty loading={this.state.loadingPeriods} />}
                          // periods hang off a material, same story
                          disabled={!this.state.material}
                        />
                          <label>
                            الفترة
                            {!this.state.material ? (
                              <small className="ui-fieldhint">اختر المادة الأول</small>
                            ) : null}
                          </label>
                      </span>
                    </div>
                  </div>
                </div>
                </section>

                <section className="ui-sec" style={{ "--d": "70ms" }}>
                  <h3>
                    <span className="n">٢</span>
                    <span className="t">
                      الفيديو
                      <small>ارفع الفيديو من جهازك، أو حطّ لينك YouTube أو Vimeo</small>
                    </span>
                  </h3>
                <div className="p-grid p-fluid">
                  {/* the picker belongs with what it reveals, so it moved here
                      from the first section -- same component, same handler */}
                  <div className="p-col-12 p-md-4 p-mt-3">
                    <div className="p-inputgroup">
                      <span className="p-float-label">
                        <Dropdown
                          value={this.state.setVideoType}
                          options={videoType}

                          onChange={(e) => this.changeVideoType(e)
                          //   this.setState({
                          //     setVideoType: e.value,
                          //     formContent: {
                          //       ...this.state.formContent,
                          //       setVideoType: e.value,
                          //     },
                          //   })
                          }
                          name="vedioes"
                          placeholder="اختر"
                        />
                          <label>نوع الفيديو</label>
                      </span>
                    </div>
                  </div>

                  {/* nothing picked yet: say what the section is waiting for,
                      instead of showing an empty card */}
                  {this.state.setVideoType !== 0 &&
                  this.state.setVideoType !== 1 &&
                  this.state.setVideoType !== 2 ? (
                    <div className="p-col-12 p-md-12">
                      <p className="ui-waiting">
                        اختر «نوع الفيديو» الأول، وهيظهر لك مكان الرفع أو اللينك هنا.
                      </p>
                    </div>
                  ) : null}

                   {(this.state.setVideoType === 0) ? (
                                        <div className="p-col-12 p-md-4 p-mt-3">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <InputText id="video-link" value={this.state.youtubeLink} name="video-link" type="text" onChange={(e) => {this.setState({

                                                   
                                                        // ...this.state.videos,
                                                        // lessonVideoList: this.state.videos.lessonVideoList.concat(res.video_url.split('/').pop()),

                                                        youtubeLink:e.target.value,
                                                       
                                                      }   )}} />
                                                      <Button    onClick={()=>uploadVideoYoutube(this.state.youtubeLink)}>اضافه</Button>

                                                    <label htmlFor="video-link">لينك Youtube</label>
                                                </span>
                                            </div>
                                        </div>
                                    ): ""} 
                                    {(this.state.setVideoType === 1) ? (
                                       <div className="p-col-12 p-md-12">
                    <div className="p-inputgroup">
                      <span className="p-float-label">
                        {
                          // (this.state.setVideoType === 1) ?
                          <FileUpload
                            name="LessonVideo"
                            customUpload
                            headerTemplate={(o) => (
                              <div className="ui-sec-head is-sub">
                                <span className="t">
                                  فيديو الحصة
                                  <small>MP4 حتى ٢ جيجا</small>
                                </span>
                                <span className="act">{o.chooseButton}</span>
                              </div>
                            )}
                            uploadHandler={uploadVideo}
                            auto
                            invalidFileSizeMessageSummary="حجم الفيديو  كبير:"
                            invalidFileSizeMessageDetail="أقصى حجم للفيديو هو (2 GB)"
                            multiple={false}
                            accept="video/*"
                            maxFileSize={2000000000}
                            chooseLabel="إختيار الفيديو"
                            uploadLabel="رفع الفيديو"
                            cancelLabel="إلغاء"
                            emptyTemplate={
                              <p className="p-m-0">
                                إسحب الفيديو هنا ليبدأ التحميل
                              </p>
                            }
                          />
                          //  : ""
                        }
                      </span>
                    </div>
                    {/* {this.state.videos.lessonVideoList.map((object, i) =>              
                   
                   <a href={`${properties.uploads_path}/videos/${object}`} download target="_blank">{`${object}`}</a>
 )}  */}
                  </div>
                                  ): ""} 
                  {(this.state.setVideoType === 2) ? (
                                        <div className="p-col-12 p-md-4 p-mt-3">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                <InputText id="video-link" value={this.state.vimeoLink} name="video-link" type="text" onChange={(e) => {this.setState({

                                                   
// ...this.state.videos,
// lessonVideoList: this.state.videos.lessonVideoList.concat(res.video_url.split('/').pop()),

vimeoLink:e.target.value,

}   )}} />
                                               <Button    onClick={()=>uploadVideoViemo(this.state.vimeoLink)}>اضافه</Button>


                                                    <label htmlFor="video-link">لينك Vimeo</label>
                                                </span>
                                            </div>
                                        </div>
                                    ): ""} 
                                    <div>
                      {this.state.formContent.videoLinks.map((object, i) =>
                   <a href={previewLink(object)} download target="_blank" rel="noreferrer" key={i}>{`${object}`}</a>
 )}

        {this.state.formContent.youtubeLinks.map((object, i) =>
        <div>
           <a href={previewLink(object)} target="_blank" rel="noreferrer" key={i}>{`${object}`}</a>
        </div>

 )}


          {this.state.formContent.vimeoLinks.map((object, i) =>
                   <div>
                   <a href={previewLink(object)} target="_blank" rel="noreferrer" key={i}>{`${object}`}</a>

                   </div>   )}


                   </div>
                </div>
                </section>

                <section className="ui-sec" style={{ "--d": "140ms" }}>
                  <h3>
                    <span className="n">٣</span>
                    <span className="t">
                      وصف الحصة
                      <small>اللي الطالب هيقراه قبل ما يفتح الحصة</small>
                    </span>
                  </h3>
                <div className="p-grid p-fluid">
                  <div className="p-col-12 p-md-12 p-mt-3">
                    <div className="p-inputgroup">
                      <span className="p-float-label">
                        <InputTextarea
                          rows={5}
                          required
                          value={this.state.formContent.lessonDescription}
                          onChange={(e) => {
                            this.setState({
                              formContent: {
                                ...this.state.formContent,
                                lessonDescription: e.target.value,
                              },
                            });
                          }}
                          name="lesson-description"
                          id="lesson-description"
                        />
                        <label htmlFor="lesson-description">وصف الحصة</label>
                      </span>
                    </div>
                  </div>
                </div>
                </section>

                <section className="ui-sec" style={{ "--d": "210ms" }}>
                <div className="p-grid p-fluid">
                  <div className="p-col-12 p-md-12">
                    <div className="p-inputgroup">
                      <span className="p-float-label">
                        {
                          // (this.state.setVideoType === 1) ?
                          <FileUpload
                            name="LessonVideo"
                            customUpload
                            /* the section's heading IS this upload's header
                               row, so the chooser sits beside the title in
                               the same element instead of in a bar below it */
                            headerTemplate={(o) => (
                              <div className="ui-sec-head">
                                <span className="n">٤</span>
                                <span className="t">
                                  الصوت
                                  <small>اختياري — نسخة صوتية من الشرح</small>
                                </span>
                                <span className="act">{o.chooseButton}</span>
                              </div>
                            )}
                            uploadHandler={onUploadVoice}
                            auto
                            invalidFileSizeMessageSummary="حجم الصوت  كبير:"
                            invalidFileSizeMessageDetail="أقصى حجم للصوت هو (2 GB)"
                            multiple={false}
                            accept="audio/*"
                            maxFileSize={2000000000}
                            chooseLabel="إختيار الصوت"
                            uploadLabel="رفع الصوت"
                            cancelLabel="إلغاء"
                            emptyTemplate={
                              <p className="p-m-0">
                                إسحب الصوت هنا ليبدأ التحميل
                              </p>
                            }
                          />
                          //  : ""
                        }
                      </span>
                    </div>
                    {this.state.formContent.lessonVoiceList.map((object, i) =>
                   <a href={previewLink(object)} download target="_blank" rel="noreferrer" key={i}>{`${object}`}</a>
)}
                  </div>
                </div>
                </section>

                <section className="ui-sec" style={{ "--d": "280ms" }}>
                <div className="p-grid p-fluid">
                  <div className="p-col-12 p-md-12">
                    <div className="p-inputgroup">
                      <span className="p-float-label">
                        <Toast ref={this.toast}></Toast>
                        <FileUpload
                          name="thumb"
                          customUpload
                          headerTemplate={(o) => (
                            <div className="ui-sec-head">
                              <span className="n">٥</span>
                              <span className="t">
                                الصورة المصغّرة
                                <small>الصورة اللي هتظهر للحصة في قائمة طلابك</small>
                              </span>
                              <span className="act">{o.chooseButton}</span>
                            </div>
                          )}
                          uploadHandler={onUploadThumb}
                          auto
                          invalidFileSizeMessageSummary="حجم الفيديو كبير:"
                          invalidFileSizeMessageDetail="أقصى حجم للصورة هو (50 MB)"
                          multiple={false}
                          accept="image/*"
                          maxFileSize={20000000}
                          chooseLabel="إختيار صورة مصغرة"
                          uploadLabel="رفع الصورة"
                          cancelLabel="إلغاء"
                          emptyTemplate={
                            <p className="p-m-0">
                              إسحب الصورة هنا ليبدأ التحميل
                            </p>
                          }
                        />
                      </span>


                    </div>
                    {this.state.thumbs.map((object, i) =>
                            <img className="preview-thumb image" src={object} alt={object} key={i} onClick={(e)=>e.target.requestFullscreen()}/>
  )}
                  </div>
                </div>
                </section>

                <section className="ui-sec" style={{ "--d": "350ms" }}>
                <div className="p-grid p-fluid">
                  <div className="p-col-12 p-md-12">
                    <div className="p-inputgroup">
                      <span className="p-float-label">
                        <Toast ref={this.toast}></Toast>
                        <FileUpload
                          name="LessonPDFs[]"
                          customUpload
                          headerTemplate={(o) => (
                            <div className="ui-sec-head">
                              <span className="n">٦</span>
                              <span className="t">
                                المذكرات
                                <small>ملفات PDF أو Word أو PowerPoint مع الحصة</small>
                              </span>
                              <span className="act">{o.chooseButton}</span>
                            </div>
                          )}
                          uploadHandler={onUploadPDFs}
                          auto
                          invalidFileSizeMessageSummary="حجم الفيديو كبير:"
                          invalidFileSizeMessageDetail="أقصى حجم للمذكرة هو (100 MB)"
                          multiple={false}
                          accept=".doc,.docx,.pdf,.ppt,.pptx"
                          maxFileSize={100000000}
                          chooseLabel="إختيار المذكرات"
                          uploadLabel="رفع المذكرات"
                          cancelLabel="إلغاء"
                          emptyTemplate={
                            <p className="p-m-0">
                              إسحب المذكرات هنا ليبدأ التحميل
                            </p>
                          }
                        />
                      </span>
                    </div>
                    {this.state.formContent.documents.map((object, i) =>
                        <a href={previewLink(object)} download target="_blank" rel="noreferrer" key={i}>{`${object}`}</a>
  )}
                    <p className="p-mt-2" style={{ fontSize: "0.85rem", color: "#888" }}>
                      المذكرات هتترفع بس تتحفظ فعلياً مع الحصة بعد ما تحفظ الحصة لأول مرة.
                    </p>
                  </div>
                </div>
                </section>

                {/* In a panel the save rides the header row; on the page it
                    keeps its own bar at the end of the form. Same element
                    either way, same state behind it. */}
                  {this.state.headerSlot ? (
                    ReactDOM.createPortal(
                      // no cancel beside it: the panel's × already closes
                      <Button
                        form="add-lesson-form"
                        className={`add-button ${this.state.buttonColor}`}
                        label={this.state.buttonText}
                        disabled={!canSave}
                      />,
                      this.state.headerSlot
                    )
                  ) : (
                    <div className="p-col-12 p-md-12">
                      <div className="p-inputgroup ui-form-actions">
                        <span className="p-float-label">
                          <Button
                            className={`add-button ${this.state.buttonColor}`}
                            label={this.state.buttonText}
                            disabled={!canSave}
                          />
                        </span>
                      </div>
                    </div>
                  )}
              </form>
            </Card>
          </div>
        </div>
        
      </div>
    );
  }
}

export default AddLessons;
